import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import FaClose from "react-icons/fa/times-circle";
import styles from "components/common/inline-tabs.scss";

export const InlineTabs = ({ tabValues }) => (
  <div className={ styles.container }>
    { tabValues.map(renderTab) }
  </div>
);

const tabValueType = PropTypes.shape({
  name: PropTypes.string,
  path: PropTypes.string,
  isSelected: PropTypes.bool
});

InlineTabs.propTypes = {
  tabValues: PropTypes.arrayOf(tabValueType).isRequired
};

const renderTab = (data) => {
  if (data.isSelected) {
    return (
      <Tab key={ data.name } selected>
        { renderTabContents(data) }
      </Tab>
    );
  }
  return (
    <Tab key={ data.name } path={ data.path }>
      { renderTabContents(data) }
    </Tab>
  );
};

const Tab = ({ children, path, selected }) => (
  <Link
    className={ selected ? styles["tab--selected"] : styles.tab }
    to={ path }
  >
    { children }
  </Link>
);

Tab.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  path: PropTypes.string,
  selected: PropTypes.bool
};

Tab.defaultProps = {
  path: null,
  selected: false
};

const renderTabContents = (data) => {
  if (!data.isCustom) {
    return data.name;
  }
  return (
    <div className={ styles["custom-tab-container"] }>
      <span className={ styles.name }>{data.name}</span>
      <span className={ styles.delete } onClick={ (e) => { e.preventDefault(); data.onDelete(); } }>
        <FaClose size={ 12 } />
      </span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/js/components/common/inline-tabs.jsx